$('.question').on('click', function () {
  $(this).next().slideToggle(500);
  $(this).toggleClass('open');
});
